module.exports = __webpack_public_path__ + "static/img/logo.75634c0f.png";